export const userDevices = [
  {
    id: 39,
    integrationType: 'televital',
    deviceType: 1,
    connectionSettings: {
      deviceId: '7d65193e-5780-11ec-be4d-0693f9518cb1',
      serialNumber: 'WTTESTDEV0003',
    },
    connectionStatus: 1,
    archived: false,
    createdAt: '2021-12-19T19:39:52.382Z',
    updatedAt: '2021-12-19T19:39:52.382Z',
    userId: 1,
    createdBy: 1,
    updatedBy: 1,
  },
];
